import FolhaDashboard from "../../components/folha-pagamento/dashboard/FolhaDashboard";

export default function () {
  return <FolhaDashboard />;
}
